import { render, staticRenderFns } from "./HealthReportFormDialog.vue?vue&type=template&id=0c8c982d"
import script from "./HealthReportFormDialog.vue?vue&type=script&lang=ts"
export * from "./HealthReportFormDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports